import { NewSearchComponent } from "@/components/new-search-component"
import { type SearchFiltersDraft } from "@/lib/search-filter-model"
import MainAppRoute from "@/rootRoutes/MainApp"
import { mapSearchFiltersToSearchPayload } from "@/utils/search-utils"
import { createRoute } from "@tanstack/react-router"
import { usePostSearchStart } from "openapi/api/endpoints"
import { BeginSearchRequest } from "openapi/api/model"
import { toast } from "sonner"


const NewSearchRoute = createRoute({
  getParentRoute: () => MainAppRoute,
  path: "/searches/new",
  component: ()=><NewSearch />,
})

export default NewSearchRoute

const NewSearch=()=>{
  const navigate = NewSearchRoute.useNavigate()
  const {mutateAsync:createSearch}=usePostSearchStart()
  const startSearch=async (query: string, filters: SearchFiltersDraft)=>{
    try{
      const {p_hash}=await createSearch({
        data:{
          ...mapSearchFiltersToSearchPayload(filters),
          prompt:query,
        } as unknown as BeginSearchRequest
      })
      if(p_hash){
        navigate({
          to:'/searches/$searchId/results',
          params:{
            searchId:p_hash,
          },
          search: {
            page: 1,
          },
        })
      }
    }catch{
      toast.error('Failed to initialize search; please adjust your filters and try again')
    }
    ////start search here hook method call here then navigate and fetch search results
    
  }
  return <NewSearchComponent onSearch={startSearch} />
}
